import { ChangeDetectorRef, Component, effect, inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import dayjs from "dayjs";
import { Subject } from "rxjs";
import { UserCreditHistory, UserCreditHistoryRepository } from "src/app/repositories/credits/user-credit-history-repository";
import { ChangePasswordComponent } from "@shared/src/lib/components/change-password/change-password";
import { CentsToDollarsPipe, NavigationService, ScreenStore, UserState, UserStore } from "@shared/src/public-api";
import { LoadingComponent } from "@shared/src/lib/components/loading/loading.component";
import { ConnectInmateComponent } from "../../components/connect-inmate/connect-inmate.component";
import { GiveCreditsComponent } from "@shared/src/lib/components/give-credits/give-credits.component";
import { PurchaseComponent } from "@shared/src/lib/stripe/purchase/purchase.component";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CivilianRegistrationRepository } from "src/app/repositories/registration/civilian-registration-repository";
import { getState } from "@ngrx/signals";
import { JhmTableComponent } from "@shared/src/lib/components/jhm-table/jhm-table.component";
import { CellClickedEvent } from "ag-grid-community";
import { CivilianSettings, CivilianSettingsRepository } from "src/app/repositories/settings/user-credit-history-repository";
import { ToastService } from "@shared/src/lib/services/toast.service";

@Component({
	selector: "jhmc-user-settings",
	templateUrl: "./user-settings.component.html",
	styleUrls: ["./user-settings.component.scss"],
	imports: [MatFormFieldModule, MatInputModule, FormsModule, JhmTableComponent,
		PurchaseComponent, GiveCreditsComponent, ConnectInmateComponent, ChangePasswordComponent, LoadingComponent,
		CentsToDollarsPipe]
})
export class UserSettingsComponent implements OnInit, OnDestroy
{
	private navigationService: NavigationService;
	// Allows us too use the ViewChild on the modal
	private changeDetectorRef: ChangeDetectorRef;

	public myMath: Math = Math;
	public selectedPage: string = "ACCOUNT";
	public showStripeModal: boolean = false;
	public showGiveCreditsModal: boolean = false;
	public showConnectInmateModal: boolean = false;
	public newEmail: string;
	public civilianSettingsRepository: CivilianSettingsRepository;
	public userCreditHistoryRepository: UserCreditHistoryRepository;
	public selectedHistory: UserCreditHistory;
	public showChangePasswordModal: boolean;
	@ViewChild("changePasswordComponent", {static: false})
	public changePasswordComponent: ChangePasswordComponent;
	public loading: boolean = false;
	public screenSize: string;
	public isMobile: boolean = false;
	public ngDestroyed$: Subject<any> = new Subject();
	public showConfirmDeleteAccount: boolean = false;
	public civilianSettings: CivilianSettings;
	public userState: UserState;
	public passwordsValid: boolean;

	readonly userStore = inject(UserStore);
	readonly screenStore = inject(ScreenStore);
	readonly toastService = inject(ToastService);

	public constructor(navigationService: NavigationService,
		civilianSettingsRepository: CivilianSettingsRepository, changeDetectorRef: ChangeDetectorRef,
		private civilianRegistrationRepository: CivilianRegistrationRepository, userCreditHistoryRepository: UserCreditHistoryRepository)
	{
		this.civilianSettingsRepository = civilianSettingsRepository;
		this.civilianRegistrationRepository = civilianRegistrationRepository;
		this.userCreditHistoryRepository = userCreditHistoryRepository;
		this.navigationService = navigationService;
		this.changeDetectorRef = changeDetectorRef;

		effect(() => {
			this.userState = getState(this.userStore);
			this.newEmail = this.userState.currentEmailOrBookingNumber;
		})

		effect(() => {
			this.screenSize = this.screenStore.screenSize();
			if (this.screenSize === "MOBILE") {
				this.isMobile = true;
			}
			else {
				this.isMobile = false;
			}
		})
	}
	ngOnInit(): void
	{
		this.civilianSettingsRepository.getCivilianSettings().subscribe({
			next: (civilianSettings: CivilianSettings) => {
				this.civilianSettings = civilianSettings;
			},
			error: (error: Error) =>
			{
				alert("Unable to get civilian settings");
			}
		})
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public goToPreviousPage(): void
	{
		this.navigationService.goToPreviousPage("/");
	}

	public switchPage(newPage: string): void
	{
		this.selectedPage = newPage;
	}

	public changePassword(): void
	{
		this.showChangePasswordModal = true;
		this.changeDetectorRef.detectChanges();
	}

	public purchaseCredits(): void
	{
		this.showStripeModal = true;
	}

	public giveCredits(): void
	{
		this.showGiveCreditsModal = true;
	}

	public connectInmateAccount(): void
	{
		this.showConnectInmateModal = true;
	}

	public deleteAccountClicked(): void
	{
		this.showConfirmDeleteAccount = true;
	}

	public confirmDeleteAccount(): void
	{
		this.civilianRegistrationRepository.deleteCivilianAccount().subscribe(() => {
			this.userStore.logout();
		});
	}

	public verifyEmail(): void
	{
		// TODO: Verify Email
	}

	public transactionClicked(cellClicked: CellClickedEvent): void
	{
		const historyObject: UserCreditHistory = cellClicked.data;
		this.selectedHistory = historyObject;
	}

	public getDateSecondsSinceEpoch(seconds: number): string
	{
		return dayjs.unix(seconds).format("MMMM D, YYYY");
	}

	public changePasswordConfirm(): void
	{
		this.changePasswordComponent.changePassword();
	}
}
